import { render, staticRenderFns } from "./SelecionaMetodo.vue?vue&type=template&id=baefd934&scoped=true"
import script from "./SelecionaMetodo.vue?vue&type=script&lang=js"
export * from "./SelecionaMetodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baefd934",
  null
  
)

export default component.exports